import { useTranslation } from 'react-i18next'
import ChangePasswordForm from '../components/ChangePasswordForm'
import Layout from './Layout'

const PageChangePassword = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <h1>{t('label.password_change')}</h1>
      <ChangePasswordForm />
    </Layout>
  )
}

export default PageChangePassword
